// Mock: ~20 speech characters ≈ 1 second of generated avatar video. Used both
// to estimate generation cost (credits) and the placeholder timeline duration,
// so they stay in sync.
export const MOCK_CHARS_PER_SECOND = 18

// Estimated seconds of avatar video for a given speech string (trimmed).
// Returns 0 for empty/blank text. Not rounded — callers round as needed
// (cost ceils after multiplying by credit; duration clamps to a minimum).
export const estimateAvatarSeconds = (text: string): number => {
  const trimmed = text.trim()
  if (!trimmed) return 0
  return trimmed.length / MOCK_CHARS_PER_SECOND
}
